/**
 * Returns a new array with duplicate values removed, preserving insertion order.
 * Uses a Set internally; converts back with Array.from to avoid spread on iterables.
 */
export function deduplicate<T>(items: T[]): T[] {
  // eslint-disable-next-line no-restricted-syntax
  return Array.from(new Set(items));
}

/**
 * Returns a new array with `item` inserted at `index`, preserving the order of the rest.
 * Pure: does not mutate `array`.
 */
export function insertAt<T>(array: readonly T[], index: number, item: T): T[] {
  return [...array.slice(0, index), item, ...array.slice(index)];
}

/**
 * Type guard narrowing an erased `unknown` to `T[]`.
 */
export function isArrayResult<T>(value: unknown): value is T[] {
  return Array.isArray(value);
}

/**
 * Returns the shared value when every entry of `values` is `===` the first one
 * (and the array is non-empty with a defined first entry); otherwise `undefined`.
 */
export function uniformValue<T>(values: readonly T[]): T | undefined {
  const first = values[0];
  if (first === undefined) {
    return undefined;
  }
  return values.every((value) => value === first) ? first : undefined;
}
